export default "__VITE_ASSET__CbioBlkH__"